import { Link } from "react-router-dom";
import { Wordmark } from "./Wordmark";
import { PilotTermsLink } from "./PilotTermsLink";
import { BRAND } from "@/brand.config";

export const AuthLayout = ({ title, subtitle, children, footer, admin = false }) => (
  <div className="min-h-screen flex flex-col" style={{ background: admin ? "var(--navy)" : "var(--paper)" }}>
    <header className="px-6 sm:px-10 py-6">
      <Link to={admin ? "/admin/login" : "/"} className="inline-block" aria-label={`${BRAND.name} home`}>
        <span style={admin ? { filter: "invert(1) hue-rotate(180deg)" } : undefined}>
          <Wordmark suffix={admin ? "Admin console" : undefined} />
        </span>
      </Link>
    </header>
    <main className="flex-1 flex items-start sm:items-center justify-center px-4 pb-16">
      <div className="ts-card w-full max-w-[440px] p-7 sm:p-9 rise">
        <h1 className="font-display text-3xl sm:text-4xl font-bold leading-none tracking-tight" style={{ color: "var(--ink)" }}>
          {title}
        </h1>
        {subtitle && <p className="text-sm mt-2 mb-6" style={{ color: "var(--muted-text)" }}>{subtitle}</p>}
        {children}
        {footer && <div className="mt-6 pt-5 border-t text-sm" style={{ borderColor: "var(--line-soft)", color: "var(--muted-text)" }}>{footer}</div>}
      </div>
    </main>
    <footer className="px-6 sm:px-10 py-5 text-xs" style={{ color: admin ? "#8A93A3" : "var(--faint)" }}>
      {BRAND.name} · {BRAND.statusLabel} · Encrypted in transit and at rest · Nothing happens without your confirmation.
      {!admin && <> · <PilotTermsLink className="underline" /></>}
    </footer>
  </div>
);
